/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-05 11:32:28
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-11-07 17:58:37
 * @FilePath: /qd-yunjing-web/src/api/servers.ts
 * @Description: jichu yemian
 */
const {
  VITE_APP_GATEWAY_PATH,
  VITE_APP_ADAPTER_PATH,
  VITE_APP_CHANNEL,
} = import.meta.env;
export default {
  base: `${VITE_APP_GATEWAY_PATH}/yunjing-base-server`,
  longforChannel: `${VITE_APP_GATEWAY_PATH}/qd-yunjing-longfor-c4`,
  backend: `${VITE_APP_GATEWAY_PATH}/qd-ems-backend`,
  alarm: `${VITE_APP_GATEWAY_PATH}/qd-ems-alarm`,
  analysis: `${VITE_APP_GATEWAY_PATH}/qd-ems-analysis`,
  ibms: `${VITE_APP_GATEWAY_PATH}/qd-ibms-backend`,
  dmpOpenAPI: `${VITE_APP_GATEWAY_PATH}/iot-dmp-openapi`,
  video: `${VITE_APP_ADAPTER_PATH}/video-cloud`,
  videoBase: `${VITE_APP_ADAPTER_PATH}/video-base`,
  qdInsight: `${VITE_APP_GATEWAY_PATH}/qd-insight`,
};
